module.exports = __webpack_public_path__ + "static/img/logo-romeflex.18a0e88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-romeflex.png
// module id = i3Gq
// module chunks = 1